<template>
  <v-menu
    v-model="showingMenu"
    v-bind:close-on-content-click="false"
    v-bind:target="target"
    location="left"
    min-width="240"
    z-index="5"
    eager
  >
    <v-list data-cy="list-podItem-badgestatus----">
      <v-list-item
        v-bind:disabled="item.badgestatus === badgeStatuses.NOTSELECTED"
        v-on:click="setBadgeStatus(badgeStatuses.NOTSELECTED)"
        data-cy=""
      >
        <v-list-item-title>{{ $t('routes.pod.badgeStatusNotSelected') }}</v-list-item-title>
      </v-list-item>

      <v-list-item
        v-bind:disabled="item.badgestatus === badgeStatuses.NEW"
        v-on:click="setBadgeStatus(badgeStatuses.NEW)"
        data-cy=""
      >
        <v-list-item-title>{{ $t('routes.pod.badgeStatusNew') }}</v-list-item-title>
      </v-list-item>

      <v-list-item
        v-bind:disabled="item.badgestatus === badgeStatuses.DRAFT"
        v-on:click="setBadgeStatus(badgeStatuses.DRAFT)"
        data-cy=""
      >
        <v-list-item-title>{{ $t('routes.pod.badgeStatusDraft') }}</v-list-item-title>
      </v-list-item>

      <v-list-item
        v-bind:disabled="item.badgestatus === badgeStatuses.PRODUCTION"
        v-on:click="setBadgeStatus(badgeStatuses.PRODUCTION)"
        data-cy=""
      >
        <v-list-item-title>{{ $t('routes.pod.badgeStatusProduction') }}</v-list-item-title>
      </v-list-item>

      <v-list-item
        v-bind:disabled="item.badgestatus === badgeStatuses.REVIEW"
        v-on:click="setBadgeStatus(badgeStatuses.REVIEW)"
        data-cy=""
      >
        <v-list-item-title>{{ $t('routes.pod.badgeStatusReview') }}</v-list-item-title>
      </v-list-item>

      <v-list-item
        v-bind:disabled="item.badgestatus === badgeStatuses.CORRECTION"
        v-on:click="setBadgeStatus(badgeStatuses.CORRECTION)"
        data-cy=""
      >
        <v-list-item-title>{{ $t('routes.pod.badgeStatusCorrection') }}</v-list-item-title>
      </v-list-item>

      <v-list-item
        v-bind:disabled="item.badgestatus === badgeStatuses.FINAL"
        v-on:click="setBadgeStatus(badgeStatuses.FINAL)"
        data-cy=""
      >
        <v-list-item-title>{{ $t('routes.pod.badgeStatusFinal') }}</v-list-item-title>
      </v-list-item>
    </v-list>

  </v-menu>
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';
import { useCommonStore } from '@/stores/CommonStore.js'

export default {
  emits: ["update:modelValue"],
  name: "PodBadgeStatusMenu",
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    target: {
      required: false,
    }
  },
  data: function() {
    return {};
  },
  methods: {
    setBadgeStatus: function(status) {
      const data = {
        id: this.item.id,
        badgestatus: status,
      };

      const podStore = usePodStore();
      podStore.updateBadgeStatus(data)
      .then(() => {
        this.$showMessage(this.$t('routes.pod.fileStatusChanged'));
      })
      .catch(function(error) {
        console.error("Cannot update pod badgestatus", error);
      });
      this.showingMenu = false;
    },
  },
  computed: {
    showingMenu: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
    badgeStatuses: function() {
      const commonStore = useCommonStore();
      return commonStore.podBadgeStatuses;
    },
    getBadgeStatusText: function() {
      if (!this.item) {
        return '';
      }

      switch (this.item.badgestatus) {
        case this.badgeStatuses.NOTSELECTED: return this.$t('routes.pod.badgeStatusNotSelected');
        case this.badgeStatuses.NEW: return this.$t('routes.pod.badgeStatusNew');
        case this.badgeStatuses.DRAFT: return this.$t('routes.pod.badgeStatusDraft');
        case this.badgeStatuses.PRODUCTION: return this.$t('routes.pod.badgeStatusProduction');
        case this.badgeStatuses.REVIEW: return this.$t('routes.pod.badgeStatusReview');
        case this.badgeStatuses.CORRECTION: return this.$t('routes.pod.badgeStatusCorrection');
        case this.badgeStatuses.FINAL: return this.$t('routes.pod.badgeStatusFinal');
        default: return '';
      }
    },
  }
}
</script>

<style>
</style>
